import { useEffect } from 'react';

import { AnalyticsEvent, analyticsService } from '~/services/analytics';
import { mainStore } from '~/stores';

export function useFirstOpenTracking(): void {
  useEffect(() => {
    if (mainStore.analytics.hasTrackedFirstOpen) {
      return;
    }
    analyticsService.track(AnalyticsEvent.FIRST_OPEN, {});
    mainStore.markFirstOpenTracked();
  }, []);
}
